<template>
  <header>
    <div class="header">
      <router-link to="/" class="logoaa">
        <img src="//spacecodeweb.oss-cn-beijing.aliyuncs.com/fe-resource/logo.png" alt="logo">
      </router-link>
      <div class="headermenu pc" >
          <router-link to="/us" class="navitem">
             <i class="chinese" @mousemove="showline(0)" @mouseleave="leaveshow">我们</i>
          </router-link>
          <router-link to="/serve" class="navitem">
            <i class="chinese" @mousemove="showline(1)" @mouseleave="leaveshow">服务</i>
          </router-link>
          <router-link to="/case" class="navitem">
             <i class="chinese" @mousemove="showline(2)" @mouseleave="leaveshow">案例</i>
          </router-link>
          <router-link to="/contact" class="navitem">
            <i class="chinese" @mousemove="showline(3)" @mouseleave="leaveshow">联系</i>
          </router-link>
          <div class="navline"></div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "HeaderNav",
  props:{
    navIndex:{
      type: Number,
      default: 0
    }
  },
  watch: {
    navIndex(index){
      var line = document.querySelectorAll('.navline')[0];
      line.style.transform = `translateX(${(index)*110+(index)*4}px)`
    }
  },
  methods: {
    showline(index){
      var line = document.querySelectorAll('.navline')[0];
      line.style.transform = `translateX(${(index)*110+(index)*4}px)`
    },
    leaveshow(){
      var line = document.querySelectorAll('.navline')[0];
      line.style.transform = `translateX(${(this.navIndex)*110+(this.navIndex)*4}px)`
    }
  },
 
};
</script>
<style lang="scss">
@import "@a/scss/headernav.scss";
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue